/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">
        {/* {project} - Pricing */}
        Carpet Area & Price Chart
      </h2>
      {/* <div className="pricing-div text-center">
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2.5 BHK</h3>
          <h4>864 - 948 Sq. ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>
            2.5 BHK <small style={{ fontSize: "1rem" }}>(With Deck)</small>{" "}
          </h3>
          <h4>923 - 948 Sq. ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
      </div> */}
      <div className="prc-tbls">
        <div className="prc-tbl">
          <span className="tbl-head">Dosti Heron</span>
          <table>
            <tr>
              <th>Typology</th>
              <th>Carpet Area (Sq.Ft.)</th>
              <th>Price</th>
            </tr>
            <tr>
              <td>2 BHK</td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
            </tr>
          </table>
        </div>
        <div className="prc-tbl">
          <span className="tbl-head">Dosti Pine</span>
          <table>
            <tr>
              <th>Typology</th>
              <th>Carpet Area (Sq.Ft.)</th>
              <th>Price</th>
            </tr>
            <tr>
              <td>2 BHK</td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
            </tr>
            <tr>
              <td>3 BHK</td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                {" "}
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
                {/* 2.34 Cr* <small>Onwards</small> */}
              </td>
            </tr>
          </table>
        </div>
        <div className="prc-tbl">
          <span className="tbl-head">Dosti Willow</span>
          <table>
            <tr>
              <th>Typology</th>
              <th>Carpet Area (Sq.Ft.)</th>
              <th>Price</th>
            </tr>
            <tr>
              <td>2 BHK</td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
            </tr>
            <tr>
              <td>3 BHK</td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  On Request
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span
        className="new-button "
        onClick={() => handleShowModal("Price Breakup")}
      >
        <span className="new-button-inner">
          <span className="underline-animation">Complete Price Breakup</span>
        </span>
      </span>
    </section>
  );
};

export default Pricing;
